const options = {
  cc: { code: 'cc', route: '/', name: 'Credit Card', description: 'Make credit card payments with Stripe.' },
  ach: { code: 'ach', route: '/', name: 'ACH (Automated Clearing House)', description: 'Link your bank account to Plaid and start to make ACH payments with Stripe.' },
  invoice: { code: 'invoice', route: '/', name: 'Invoice Account', description: '' },
  other: { code: 'other', route: '/', name: 'Other', description: '' }
};

const forwarderOptions = [
  options.cc,
  options.ach
];

const ghaSpecificOptions = [
  options.invoice,
  options.other
];

export {
  forwarderOptions,
  ghaSpecificOptions
};